import { LOOSE_PAGES_CHAPTER_ID, type ReceivedVision } from '@sorrem/shared';

/**
 * Sets a chapter's visions in place, as the server will: these visions, in
 * this order, are the chapter's; one the chapter held but the list leaves out
 * goes to the end of the loose pages (for the loose pages themselves, it
 * stays, after the listed ones); every place a vision left is renumbered
 * 0, 1, 2, ... in order. Ids that aren't among `visions` are ignored.
 */
export function setChapterVisionsInPlace(visions: ReceivedVision[], chapterId: string, visionIds: readonly string[]): void {
    const inPlace = (place: string): ReceivedVision[] => visions
        .filter((vision) => vision.chapterId === place)
        .sort((a, b) => a.position - b.position);
    const listed = visionIds.flatMap((id) => visions.find((vision) => vision.visionId === id) ?? []);
    const leftOut = inPlace(chapterId).filter((vision) => !listed.includes(vision));
    const sources = new Set(listed.map((vision) => vision.chapterId).filter((place) => place !== chapterId));

    const isLoose = chapterId === LOOSE_PAGES_CHAPTER_ID;
    (isLoose ? [...listed, ...leftOut] : listed).forEach((vision, index) => {
        vision.chapterId = chapterId;
        vision.position = index;
    });
    if (!isLoose) {
        [...inPlace(LOOSE_PAGES_CHAPTER_ID), ...leftOut].forEach((vision, index) => {
            vision.chapterId = LOOSE_PAGES_CHAPTER_ID;
            vision.position = index;
        });
    }
    for (const source of sources) {
        inPlace(source).forEach((vision, index) => {
            vision.position = index;
        });
    }
}
